export default __webpack_public_path__ + "static/media/close-eyes.e92939ff.svg";